import React, { useState } from 'react';
import RowHeader from './project-single-row-header';
import Row1Up from './project-single-row-1up';
import Row2Up from './project-single-row-2up';
import RowSplit from './project-single-row-split';
import RowVideoGallery from './project-single-row-video-gallery';
import RowPhone from './project-single-row-phone';

function ProjectRow(row) {
  const type = row._type;
  const textColor = row.textColor ? row.textColor.hex : 'inherit';
  const bgColor = row.bgColor ? row.bgColor.hex : 'inherit';

  if (type == 'projectRowHeader') {
    return <RowHeader type={type} row={row} textColor={textColor} bgColor={bgColor} />;
  }
  if (type == 'projectRow1Up') {
    return <Row1Up type={type} row={row} textColor={textColor} bgColor={bgColor} />;
  }
  if (type == 'projectRow2Up') {
    return <Row2Up type={type} row={row} textColor={textColor} bgColor={bgColor} />;
  }
  if (type == 'projectRowSplit') {
    return <RowSplit type={type} row={row} textColor={textColor} bgColor={bgColor} />;
  }
  if (type == 'projectRowVideoGallery') {
    return <RowVideoGallery type={type} row={row} textColor={textColor} bgColor={bgColor} />;
  }
  if (type == 'projectRowPhone') {
    return <RowPhone type={type} row={row} textColor={textColor} bgColor={bgColor} />;
  }
}

export default ProjectRow;
